

export default {

    filters: {
        limit: function(array, length) {
            var limitCount = parseInt(length, 10);
            if (limitCount <= 0) {
                ("development") !== 'production' && _.warn(
                    'The limit filter requires an argument defining the limit count.'
                );
                return array;
            }
            return array.slice(0, limitCount) + '...';
        }
    },

    methods: {

        empty(mixedVar) {
            return this.$helper.empty(mixedVar)
        },

        nl2br(str, is_xhtml) {
            return this.$helper.nl2br(str, is_xhtml)
        },

        isType(type) {
            return this.company.typeString === type
        },

        trackMailto(email) {
            this.trackEvent('email', email)
        },

        trackPhone(phone) {
            this.trackEvent('phone', phone)
        },

        trackSocial(type, ev) {
            const v = ev.currentTarget.getAttribute('href')
            this.trackEvent(type, v)
        },

        trackLink(ev) {
            const v = ev.currentTarget.getAttribute('href')
            this.trackEvent('website', v)
        },

        trackEvent(e, v) {

            if(this.internalVisit) {
                return
            }

            let pid = this.company.id
            let did = 0

            if(this.company.isMasterProfile) {
                did = 0
            } else {
                did = this.destination.id
            }

            var data = { e: e, pid: pid, did: did, v: v }

            this.sendTrackEvent(data)

        },

        async sendTrackEvent(data) {

            try{
                const response = await this.$axios.$post(this.$ziggy.route('log.profile.event'), data)
            } catch (e) {
                this.$logger.captureException(e)
            }

        },

        handleCopyEvent(event) {

            const link = this.filterCopyEvent(event)

            if(link === false || link === undefined || link === '') {
                return false
            }

            var trackEvent = link.getAttribute('data-track-event');
            var trackCid = link.getAttribute('data-track-cid');
            var trackDid = link.getAttribute('data-track-did');
            var trackValue = link.getAttribute('href');

            var data = { e: trackEvent, pid: trackCid, did: trackDid, v: trackValue };

            this.sendTrackEvent(data)

        },

        filterCopyEvent(event) {

            const target = event.target

            if (target.dataset.trackEvent != undefined) {
                return target
            }

            let link = target.querySelector('a')

            if(!link) {
                link = target.closest('a')
            }

            if(!link) {
                return false
            }

            if(link.dataset.trackEvent != undefined) {
                return link
            }

            if(link.classList.contains('cpytrck')) {
                return link
            }

        },

        chunked(array, size) {
            return this.$helper.chunk(array, size)
        },

        async toggleFavorite() {

            try{
                const response = await this.$axios.$get(this.$ziggy.route('api.profile.company.result', {destination: this.destination.id}))
                const company = response.data

                if(this.isFavorite) {
                    this.$store.dispatch("search/removeFromFavorites", company)
                } else {
                    this.$store.dispatch("search/addToFavorites", company)
                }

            } catch (e) {
                this.$logger.captureException(e)
            }

        },

        async addToRequest() {

            try{
                const response = await this.$axios.$get(this.$ziggy.route('api.profile.company.result', {destination: this.destination.id}))
                const company = response.data

                this.$store.dispatch("search/addItem", company);

            } catch (e) {
                this.$logger.captureException(e)
            }

        },

    },

    computed: {

        companyTypeColorBackground() {
            return { backgroundColor: '#'+this.company.typeColor}
        },

        hasStarRating() {

            if(this.company.typeString !== 'hotel') {
                return false
            }

            if(this.destination.starRating > 0) {
                return true
            }

            return false

        },

        starRating() {
            return this.destination.starRating
        },

        isFavorite() {
            const found = this.$store.state.search.favoriteCart.find(cart => cart.id === this.company.id)

            if(found) {
                return true
            }

            return false

        },

        getNoFollow() {

            if(this.company.isMasterProfile) {
                return false
            }

            if(this.destination.noFollow) {
                return 'nofollow'
            } else {
                return false
            }
        },

        contactData() {

            let source;

            if(this.company.isMasterProfile || this.destination.useCompanyContact == 1) {
                source = this.company
            } else {
                source = this.destination
            }

            const data = {
                'phoneDisplay': source['phoneDisplay'],
                'phoneLink': source['phoneLink'],
                'phoneParts': source['phoneParts'],
                'phoneEncode': source['phoneEncode'],

                'email': source['email'],
                'emailParts': source['emailParts'],

                'websiteDisplay': source['websiteDisplay'],
                'fixedWebsiteUrl': source['fixedWebsiteUrl'],
            }

            if(this.company.isMasterProfile === false && this.destination.useCompanyContact == 0) {

                const website = this.destination.contactWebsite

                if( !website || website === '' || website === null) {
                    data.websiteDisplay = this.company.websiteDisplay
                    data.fixedWebsiteUrl = this.company.fixedWebsiteUrl
                }

            }

            return data

        },

        trackDid() {

            if(this.company.isMasterProfile) {
                return 0
            }
            return this.destination.id

        },

        hasSocialMedia() {
            if(this.fixedLinkedinUrl !== '') {
                return true
            }

            if(this.fixedYoutubeUrl !== '') {
                return true
            }

            if(this.fixedFacebookUrl !== '') {
                return true
            }

            if(this.fixedTwitterUrl !== '') {
                return true
            }

            if(this.fixedInstagramUrl !== '') {
                return true
            }

            return false
        },




    }

}

